import Core from '../plugin-core-system/core.class.js';

export default class CsResponsiveVideo extends Core {

  static options = {

  };

  /**
   * init responsive video
   */
  initResponsiveVideo() {
    const videos = document.querySelectorAll('.js-responsive-video');

    const setSources = (video) => {

      const source = video.querySelector('source');
      const { small, medium, large, xlarge } = video.dataset;

      let newSrc = '';
      if (window.innerWidth <= 480) {
        newSrc = small;
      } else if (window.innerWidth <= 640) {
        newSrc = medium;
      } else if (window.innerWidth <= 1280) {
        newSrc = large;
      } else {
        newSrc = xlarge;
      }

      if (source.getAttribute('src') !== newSrc) {
        source.setAttribute('src', newSrc);
        video.load();
      }
    };

    const handleResize = () => {
      videos.forEach(video => {
        setSources(video);
      });
    };

    videos.forEach(video => {
      setSources(video);
    });

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        handleResize();
      }, 100);

    });
  }

  init() {
    this.initResponsiveVideo();
  }
}
